const DRIVER_DOCS = [
  {
    id: "kbisPath",
    type: "pdf",
    url: "",
    label: "KBIS",
    key: "kbisPath",
  },
  {
    id: "ribPath",
    type: "pdf",
    url: "",
    label: "RIB",
    key: "ribPath",
  },
  {
    id: "permit_solde_path",
    type: "pdf",
    url: "",
    key: "permit_solde_path",
    label: "Solde de permis de conduire",
  },
  {
    id: "idPath",
    type: "image",
    url: "",
    label: "Pièce d’identité (recto)",
    key: "idPath",
  },
  {
    id: "idPath2",
    type: "image",
    url: "",
    label: "Pièce d’identité (verso)",
    key: "idPath2",
  },
  {
    id: "drivingLicensePath",
    type: "image",
    url: "",
    label: "Permis de conduire (recto)",
    key: "drivingLicensePath",
  },
  {
    id: "drivingLicensePath2",
    type: "image",
    url: "",
    label: "Permis de conduire (verso)",
    key: "drivingLicensePath2",
  },
  {
    id: "vigilance_certificate_path",
    type: "pdf",
    url: "",
    key: "vigilance_certificate_path",
    label: "Certificat de vigilance",
  },
  {
    id: "insurance_document_path",
    type: "pdf",
    url: "",
    key: "insurance_document_path",
    label: "Attestation d'assurance RC PRO",
  },
];
export default DRIVER_DOCS;
